import React from 'react';
import classNames from 'classnames';
import DropTarget from './DropTarget';

const QuestionButton = ({ label, ...props }) => (
  <button
    {...props}
    type="button"
    className="NewButton NewButton--white NewButton--center"
    children={label}
  />
);

const getContainerClassName = ({ isOver, canDrop }) =>
  classNames('QuestionBankElement-createQuestionContainer', {
    'is-over': isOver && canDrop,
  });

const CreateQuestion = props =>
  props.connectDropTarget(
    <div className={getContainerClassName(props)}>
      <h4>Drag and drop an existing question here, or create a new one</h4>
      <div className="QuestionBankElement-buttonsContainer">
        <QuestionButton
          label="Free Response"
          onClick={() => props.onClick('Questions::FreeResponse')}
        />
        <QuestionButton
          label="Multiple Choice"
          onClick={() => props.onClick('Questions::MultipleChoice')}
        />
        <QuestionButton
          label="Multiple Select"
          onClick={() => props.onClick('Questions::MultipleSelect')}
        />
        <QuestionButton
          label="Survey"
          onClick={() => props.onClick('Questions::Survey')}
        />
      </div>
    </div>,
  );

export default DropTarget(CreateQuestion);
